'use strict';

var _ = require('lodash');
var FaresOptimizerOptionsModalController = function FaresOptimizerOptionsModalController($timeout, $scope, criteriaRuleService, faresOptimizerAnalysisOptionsConfigurationService) {
  var DEFAULT_GROUP_BY_SELECTION = ['Host Carrier', 'Market', 'Cabin'];
  $scope.screenState.selectedGroupByItems = [];
  $scope.availableGroupByItems = [];
  $scope.availableSortByItems = [];
  $scope.handleOrderOptionsChange = function () {
    $scope.screenState.orderOptions.groupBy = getSelectedGrouping($scope.screenState.selectedGroupByItems);
    $scope.screenState.orderOptions.sortBy = updateSelectedSortByItems($scope.screenState.selectedSortByItems);
    $scope.screenState.resetPageNumber = true;
  };
  function getSelectedGrouping(selectedGroupByItems) {
    return _.cloneDeep(_.filter(faresOptimizerAnalysisOptionsConfigurationService.getGroupByItems(), function (element) {
      return selectedGroupByItems.includes(element.label);
    }));
  }
  function updateSelectedSortByItems(selectedSortByItems) {
    _.forEach(selectedSortByItems, function (sortByItem) {
      _.forEach(faresOptimizerAnalysisOptionsConfigurationService.getSortByItems(), function (sortByConfig) {
        if (sortByConfig.label === sortByItem.label) {
          sortByItem.field = sortByConfig.field;
        }
      });
    });
    return _.cloneDeep(selectedSortByItems);
  }
  $scope.handleModalHideAndResetItsState = function () {
    $scope.screenState.showOptionsModal = false;
  };
  $scope.resetGroupByAndSortByValues = function () {
    $scope.updateGroupByValues();
    $scope.updateSortByValues();
    $scope.loadToggleButtons();
    $scope.screenState.selectedGroupByItems = _.cloneDeep(DEFAULT_GROUP_BY_SELECTION);
    $scope.screenState.selectedSortByItems = faresOptimizerAnalysisOptionsConfigurationService.getSortByItems();
    $scope.screenState.showOptionsModal = true;
  };
  $scope.updateGroupByValues = function () {
    $scope.availableGroupByItems = faresOptimizerAnalysisOptionsConfigurationService.loadGroupByItemsFromConfig();
    $scope.screenState.selectedGroupByItems = $scope.screenState.selectedGroupByItems.concat(DEFAULT_GROUP_BY_SELECTION);
    $scope.screenState.selectedGroupByItems = _.uniqWith($scope.screenState.selectedGroupByItems, _.isEqual);
  };
  $scope.updateSortByValues = function () {
    $scope.availableSortByItems = faresOptimizerAnalysisOptionsConfigurationService.loadSortByItemsFromConfig();
    $scope.screenState.selectedSortByItems = _.cloneDeep($scope.screenState.orderOptions.sortBy);
  };
  $scope.loadToggleButtons = function () {
    $scope.toggleButtons = faresOptimizerAnalysisOptionsConfigurationService.getToggleButtons();
  };
  $scope.updateGroupByValues();
  $scope.updateSortByValues();
  $scope.loadToggleButtons();
};
FaresOptimizerOptionsModalController.$inject = ['$timeout', '$scope', 'CriteriaRuleService', 'FaresOptimizerAnalysisOptionsConfigurationService'];
module.exports = FaresOptimizerOptionsModalController;